import apiClient from '../axios.js';

export const marketingCampaignService = {
  getCampaigns: async (params = {}) => {
    return apiClient.get('/marketing/campaigns', { params });
  },

  getCampaign: async (id) => {
    return apiClient.get(`/marketing/campaigns/${id}`);
  },

  createCampaign: async (payload) => {
    return apiClient.post('/marketing/campaigns', payload);
  },

  updateCampaign: async (id, payload) => {
    return apiClient.put(`/marketing/campaigns/${id}`, payload);
  },

  getDeleteImpact: async (id) => {
    return apiClient.get(`/marketing/campaigns/${id}/delete-impact`);
  },

  deleteCampaign: async (id, options = {}) => {
    return apiClient.delete(`/marketing/campaigns/${id}`, {
      params: {
        deleteData: options.deleteData === true
      }
    });
  },

  validateCampaign: async (id) => {
    return apiClient.post(`/marketing/campaigns/${id}/validate`);
  },

  activateCampaign: async (id) => {
    return apiClient.post(`/marketing/campaigns/${id}/activate`);
  },

  deactivateCampaign: async (id) => {
    return apiClient.post(`/marketing/campaigns/${id}/deactivate`);
  },

  getPlaybooks: async () => {
    return apiClient.get('/marketing/campaigns/playbooks');
  },

  getPlaybook: async (playbookCode) => {
    return apiClient.get(`/marketing/campaigns/playbooks/${encodeURIComponent(playbookCode)}`);
  },

  instantiateFromPlaybook: async (payload) => {
    return apiClient.post('/marketing/campaigns/instantiate-from-playbook', payload);
  },

  getAnalyticsSummary: async (id, params = {}) => {
    return apiClient.get(`/marketing/campaigns/${id}/analytics/summary`, { params });
  },

  getAnalyticsOverview: async (params = {}) => {
    return apiClient.get('/marketing/campaigns/analytics/overview', { params });
  },

  getAnalyticsFunnel: async (id, params = {}) => {
    return apiClient.get(`/marketing/campaigns/${id}/analytics/funnel`, { params });
  },

  getParticipants: async (id, params = {}) => {
    return apiClient.get(`/marketing/campaigns/${id}/participants`, { params });
  },

  saveCampaignSteps: async (id, steps) => {
    return apiClient.put(`/marketing/campaigns/${id}/steps`, { steps });
  },

  previewEligibility: async (payload) => {
    return apiClient.post('/marketing/campaigns/eligibility/preview', payload);
  },

  estimateFlowOverview: async (payload) => {
    return apiClient.post('/marketing/campaigns/flow-overview/estimate', payload);
  },

  listRewardReissues: async (params = {}) => {
    return apiClient.get('/marketing/reward-reissues', { params });
  },

  reissueRewards: async (payload) => {
    return apiClient.post('/marketing/reward-reissues/reissue', payload);
  },

  dismissRewardReissues: async (ids) => {
    return apiClient.post('/marketing/reward-reissues/dismiss', { ids });
  }
};
